import { render, staticRenderFns } from "./TripHistory3.vue?vue&type=template&id=28d0f2de&scoped=true"
import script from "./TripHistory3.vue?vue&type=script&lang=js"
export * from "./TripHistory3.vue?vue&type=script&lang=js"
import style0 from "./TripHistory3.vue?vue&type=style&index=0&id=28d0f2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d0f2de",
  null
  
)

export default component.exports